import './Services.css'

import Presta from '../../components/Presta/Presta'

export default function Services() {
    return (
        <main>
            <Presta />
        </main>
    )
}